
/* i18n (Sache): vertalingen + taal-prefix voor links, gevuld vanuit theme.liquid */
const SB_T = window.SB_T || {}, SB_LR = window.SB_LR || "";
function tr(s){ if(typeof s!=="string") return s; if(SB_T[s]) return SB_T[s]; var m=/^Alle (.+) onderdelen$/.exec(s); if(m&&SB_T._allparts) return SB_T._allparts.replace("%s",tr(m[1])); m=/^(.+) onderdelen$/.exec(s); if(m&&SB_T._parts) return SB_T._parts.replace("%s",m[1]); return s; }
function lp(h){ return (typeof h==="string" && h.charAt(0)==="/" && h.charAt(1)!=="/") ? SB_LR+h : h; }
/* ====================================================
   DATA — pas deze arrays aan met je eigen producten,
   categorieen, locaties en merken.
   ==================================================== */

/* ====================================================
   MENU / NAVIGATIE — pas dit aan om je categorieen en
   onderdelen te koppelen. Per item:
     {label, href, deals?, wide?, items:[ [naam, link], ... ]}
   - 'items' => uitklapmenu (dropdown). Laat weg voor losse link.
   - 'wide:true' => brede dropdown in 2 kolommen (handig bij veel items).
   - regel ["—HEAD—","Kopjenaam"] toont een kopje in de dropdown.
   ==================================================== */
const NAV = [
  { label:"Deals", href:"/collections/aanbiedingen", deals:true },

  { label:"Fatbikes", href:"/collections/fatbikes", items:[
    ["Ouxi","/collections/fatbike-ouxi"], ["Qmwheel","/collections/fatbike-qmwheel"], ["7GO","/collections/fatbike-7go-rse"], ["AGM","/collections/agm-bike"], ["Windgoo","/collections/fatbike-windgoo"], ["Pixar","/collections/fatbike-pixar"], ["Alle fatbikes","/collections/fatbikes"],
  ]},

  { label:"Citybikes", href:"/collections/citybike" },

  /* Onderdelen = twee niveaus: merk (links) -> modellen (rechts). */
  { label:"Onderdelen", href:"/collections/fatbike-onderdelen", groups:[
    { name:"Ouxi", items:[
      ["V8 onderdelen","/collections/onderdelen-ouxi-v8"], ["V8 Ultra onderdelen","/collections/onderdelen-ouxi-v8-ultra"], ["H9 onderdelen","/collections/onderdelen-ouxi-h9"], ["C80 onderdelen","/collections/onderdelen-ouxi-c80"], ["Mini C80 onderdelen","/collections/onderdelen-ouxi-mini-c80"], ["GT2000 onderdelen","/collections/onderdelen-ouxi-gt2000"], ["GT16 onderdelen","/collections/onderdelen-ouxi-gt16"], ["Alle Ouxi onderdelen","/collections/onderdelen-ouxi"],
    ]},
    { name:"Qmwheel", items:[
      ["V20 onderdelen","/collections/onderdelen-qmwheel-v20"], ["V20 Pro onderdelen","/collections/onderdelen-qmwheel-v20-pro"], ["V20 Mini onderdelen","/collections/onderdelen-qmwheel-v20-mini"], ["V20 Cross onderdelen","/collections/onderdelen-qmwheel-v20-cross"], ["V29 onderdelen","/collections/onderdelen-qmwheel-v29"], ["S20 onderdelen","/collections/onderdelen-qmwheel-s20"], ["V30 onderdelen","/collections/onderdelen-qmwheel-v30"], ["Alle Qmwheel onderdelen","/collections/onderdelen-qmwheel"],
    ]},
    { name:"7GO", items:[
      ["EB2 onderdelen","/collections/onderdelen-7go-eb2"], ["EB3 onderdelen","/collections/onderdelen-7go-eb3"], ["EB4 onderdelen","/collections/onderdelen-7go-eb4"], ["EB8 onderdelen","/collections/onderdelen-7go-eb8"], ["EB13 onderdelen","/collections/onderdelen-7go-eb13"], ["RSE onderdelen","/collections/onderdelen-rse"], ["Alle 7GO en RSE onderdelen","/collections/onderdelen-7go"],
    ]},
    { name:"AGM", items:[
      ["GT250 onderdelen","/collections/onderdelen-agm-gt250"], ["Alle AGM onderdelen","/collections/onderdelen-agm"],
    ]},
    { name:"Pixar", items:[
      ["C1 onderdelen","/collections/onderdelen-pixar-c1"], ["C1 Pro onderdelen","/collections/onderdelen-pixar-c1-pro"], ["Cruiser onderdelen","/collections/onderdelen-pixar-cruiser"], ["Forge onderdelen","/collections/onderdelen-pixar-forge"], ["Largo onderdelen","/collections/onderdelen-pixar-largo"], ["M9 onderdelen","/collections/onderdelen-pixar-m9"], ["Rusher onderdelen","/collections/onderdelen-pixar-rusher"], ["Alle Pixar onderdelen","/collections/onderdelen-pixar"],
    ]},
    { name:"Windgoo", items:[
      ["B20 Pro onderdelen","/collections/onderdelen-windgoo-b20-pro"], ["Alle Windgoo onderdelen","/collections/onderdelen-windgoo"],
    ]},
    { name:"Koolux", items:[
      ["X9 / X9 Pro onderdelen","/collections/onderdelen-koolux-x9"], ["Alle Koolux onderdelen","/collections/onderdelen-koolux"],
    ]},
    { name:"Per onderdeel", items:[
      ["Accu's","/collections/accu-fatbike"], ["Opladers","/collections/oplader-fatbike"], ["Controllers","/collections/controller-fatbike"], ["Displays","/collections/display-fatbike"],
      ["Motoren","/collections/motor-fatbike"], ["Trapsensoren","/collections/trapsensor-fatbike"], ["Kabelbomen","/collections/kabelboom-fatbike"], ["Remmen","/collections/remmen-fatbike"],
      ["Verlichting","/collections/verlichting-fatbike"], ["Banden en binnenbanden","/collections/banden-fatbike"], ["Ketting en aandrijving","/collections/aandrijving-fatbike"], ["Alle onderdelen","/collections/fatbike-onderdelen"],
    ]},
  ]},

  { label:"Accessoires", href:"/collections/accessoires", items:[
    ["Sloten en alarmen","/collections/sloten-en-alarmen"], ["Gereedschap","/collections/gereedschap"], ["Banden","/collections/banden-fatbike"], ["Alle accessoires","/collections/accessoires"],
  ]},

  { label:"Werkplaats", href:"/pages/afspraak-maken", cols:[
    { head:"Afspraak", items:[
      ["Onderhoud of reparatie","/pages/afspraak-maken","Vaak dezelfde dag klaar","wrench"],
      ["Proefrit plannen","/pages/proefrit-plannen","Gratis in beide winkels","bike"],
      ["Fatbike huren","/pages/fatbike-huren-den-haag","Per dag of per week","key"],
    ]},
    { head:"Onze winkels", items:[
      ["Den Haag","/pages/fatbike-winkel-den-haag","Calandkade 44-45 · di t/m za","pin"],
      ["Zoetermeer","/pages/fatbike-winkel-zoetermeer","Philipsstraat 3B · ma t/m za","pin"],
    ]},
  ], promo:{t:"Fatbike kapot?", p:"Plan direct een afspraak. Onderdelen hebben we zelf op voorraad.", cta:"Afspraak maken", href:"/pages/afspraak-maken", green:true} },

  { label:"Hulp", href:"/pages/fatbike-adviseur", cols:[
    { head:"Kiezen", items:[
      ["Fatbike adviseur","/pages/fatbike-adviseur","In 1 minuut de juiste fiets","chat"],
      ["Fatbikes vergelijken","/pages/vergelijken","Tot 4 modellen naast elkaar","scale"],
      ["Fatbike regels 2026","/pages/fatbike-regels","Wat mag wel en niet","doc"],
      ["Fatbike rechtszaken","/pages/fatbike-rechtszaken","Laatste uitspraken, elke week bijgewerkt","scale"],
      ["Betalen met in3 of Klarna","/pages/fatbike-in-termijnen-betalen","in3, Klarna, iDEAL en meer","card"],
    ]},
    { head:"Storing en uitleg", items:[
      ["Foutcodes per display","/pages/foutcodes","Code opzoeken en direct advies","alert"],
      ["Storing per model","/pages/fatbike-storingen","Fiets doet het niet meer","wrench"],
      ["Handleidingen","/pages/handleiding-fatbike","PDF per model","book"],
    ]},
    { head:"Na je aankoop", items:[
      ["Garantie of melding","/pages/garantie-aanvragen","In 2 minuten via WhatsApp","check"],
      ["Gestolen of schade","/pages/fatbike-gestolen","Stappenplan en taxatie","shield"],
      ["Retourformulier","/pages/retourformulier","Product terugsturen","ret"],
      ["Garantievoorwaarden","/pages/garantie","Wat valt eronder","doc"],
      ["Veelgestelde vragen","/pages/veelgestelde-vragen","Snel antwoord","help"],
    ]},
  ], promo:{t:"Niet zeker welke fatbike?", p:"Beantwoord een paar vragen en zie direct welke modellen bij je passen.", cta:"Start de adviseur", href:"/pages/fatbike-adviseur"} },
];

/* icoon per menu-kopje (zelfde labels als in NAV) */
const NAV_ICONS = {
  "Fatbikes":"M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm14 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 14l4-6h5l3 6m-8-6 4 6m-3-6h4",
  "CityBikes":"M4 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm14 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM4 15l6-7 6 7m-6-7v7",
  "Onderdelen":"M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-6 1.5 3 3.3-.6-.6 3.3L20 12l-2.8 1.6.6 3.3-3.3-.6L12 20l-1.5-2.7-3.3.6.6-3.3L4 12l2.8-1.6-.6-3.3 3.3.6L12 2Z",
  "Accessoires":"M12 2a3 3 0 0 1 3 3v2H9V5a3 3 0 0 1 3-3ZM5 8h14l-1 12H6L5 8Z",
  "Werkplaats":"M7 2v3M17 2v3M3.5 8.5h17M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm3.5 9.5 2 2 4-4",
  "Hulp":"M21 11.5a8 8 0 0 1-11.5 7.2L3 21l2.3-6.5A8 8 0 1 1 21 11.5Z",
};

/* prijs in hele euro's; "was" optioneel; deal = % korting; new = nieuw label */
const PRODUCTS = [
  {name:"Sache V20 Pro — Zwart", now:999, was:1099, reviews:11, deal:10, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#2b2b30", c2:"#46464d"},
  {name:"Sache C80 — Zwart", now:899, was:1399, reviews:152, deal:36, new:true, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#1f1f24", c2:"#3a3a42"},
  {name:"Sache GT-2000 Off-road — Groen", now:1499, reviews:8, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#27352a", c2:"#3f5a45"},
  {name:"Sache Pro Mini — Zwart", now:849, was:999, reviews:11, deal:16, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#23232a", c2:"#41414a"},
  {name:"Sache C80 MAX (Dubbele accu)", now:1199, was:1599, reviews:50, deal:26, ship:"Levertijd 1-3 werkdagen", tag:"deal", c1:"#1c1c22", c2:"#393941"},
  {name:"Sache L20 — Zwart", now:1049, was:1199, reviews:70, deal:13, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#222228", c2:"#3d3d46"},
  {name:"Sache Q10 — Off White", now:1149, was:1299, reviews:5, deal:12, ship:"Levertijd 1-3 werkdagen", tag:"deal", c1:"#d8d2c4", c2:"#efe9dd", dark:true},
  {name:"Sache V8 Ultra — Zwart", now:999, was:1249, reviews:9, deal:21, ship:"Levertijd 1-3 werkdagen", tag:"deal", c1:"#1e1e24", c2:"#3a3a43"},
  {name:"Sache S20 Pro — Zwart", now:1099, was:1199, reviews:2, deal:9, ship:"Levertijd 1-3 werkdagen", tag:"best", c1:"#242424", c2:"#444"},
  {name:"Sache E26 Hoge instap — Zwart", now:1499, was:1599, reviews:14, deal:7, ship:"Levertijd 1-3 werkdagen", tag:"deal", c1:"#202026", c2:"#3c3c44"},
  {name:"Sache Cross — Zwart", now:1099, reviews:1, ship:"Levertijd 1-2 weken", tag:"deal", c1:"#1f1f25", c2:"#3a3a42"},
  {name:"Sache V20 Limited — Zwart", now:999, was:1099, reviews:1, deal:10, ship:"Levertijd 1-2 weken", tag:"best", c1:"#212128", c2:"#3d3d47"},
];

const LOCATIONS = [
  ["Showroom Zoetermeer","Philipsstraat 3B, Zoetermeer"],
  ["Winkel Den Haag","Calandkade 44-45, Den Haag"],
];

const BRANDS = ["ENGWE","V20","OUXI","JOBOBIKE","VOGUE","DIABLO","PHATFOUR","AGM","STOER","TOMOS","7GO","ApeRyder","KNAAP","PULSE","SEGWAY","KADRA","Fiido","SKYJET"];

/* ---------- render helpers ---------- */
const euro = n => n.toLocaleString("nl-NL");

function bikeSVG(c1,c2,dark){
  const stroke = dark ? "#2a2a2a" : "#EDE7DC";
  return `<svg class="ph" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Productafbeelding placeholder">
    <defs><linearGradient id="g${c1.replace('#','')}" x1="0" x2="1" y1="0" y2="1">
      <stop offset="0" stop-color="${c2}"/><stop offset="1" stop-color="${c1}"/></linearGradient></defs>
    <rect width="200" height="200" fill="url(#g${c1.replace('#','')})"/>
    <g transform="translate(0,14)">
      <circle cx="62" cy="128" r="34" fill="none" stroke="#1C90E6" stroke-width="7"/>
      <circle cx="146" cy="128" r="34" fill="none" stroke="#1C90E6" stroke-width="7"/>
      <circle cx="62" cy="128" r="15" fill="none" stroke="${stroke}" stroke-width="3" opacity=".6"/>
      <circle cx="146" cy="128" r="15" fill="none" stroke="${stroke}" stroke-width="3" opacity=".6"/>
      <path d="M62 128 100 82h40l24 46M100 82l28 46M92 82h22" fill="none" stroke="${stroke}" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M138 82l8-12h14" fill="none" stroke="${stroke}" stroke-width="6" stroke-linecap="round"/>
      <path d="M58 128h44" stroke="${stroke}" stroke-width="6" stroke-linecap="round"/>
      <rect x="94" y="75" width="22" height="7" rx="3" fill="#1C90E6"/>
    </g></svg>`;
}

function card(p){
  const stars = "★★★★★";
  const badges = [];
  if(p.new) badges.push(`<span class="b-new">NIEUW</span>`);
  if(p.deal) badges.push(`<span class="b-deal">-${p.deal}%</span>`);
  const slow = /weken/.test(p.ship);
  return `<article class="card">
    <div class="media">
      <div class="badges">${badges.join("")}</div>
      ${bikeSVG(p.c1,p.c2,p.dark)}
    </div>
    <div class="body">
      <div class="stars"><span class="s">${stars}</span> ${p.reviews ? p.reviews+" reviews" : "Nieuw"}</div>
      <h3>${p.name}</h3>
      <div class="price">
        <span class="now">€ ${euro(p.now)},-</span>
        ${p.was ? `<span class="was">€ ${euro(p.was)},-</span>` : ""}
      </div>
      <div class="ship ${slow?'slow':''}">
        ${slow?'':'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>'}
        ${p.ship}
      </div>
      <button class="add" data-name="${p.name}">In mandje
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6h15l-1.5 9h-12L5 3H2"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>
      </button>
    </div>
  </article>`;
}

/* ---------- mount ---------- */

// ---- helpers voor dropdowns (plat of twee-niveau) ----
const QMW_LOGO = `<img class="blogo qmw" src="${(window.SB_ASSETS||"")}brand-qmwheel.webp" alt="Qmwheel">`;
const OUXI_LOGO = `<img class="blogo ouxi" src="${(window.SB_ASSETS||"")}brand-ouxi.webp" alt="OUXI">`;
const SEVENGO_LOGO = `<img class="blogo sevengo" src="${(window.SB_ASSETS||"")}brand-7go.webp" alt="7GO">`;
const AGM_LOGO = `<img class="blogo agm" src="${(window.SB_ASSETS||"")}brand-agm.webp" alt="AGM">`;
const WINDGOO_LOGO = `<img class="blogo windgoo" src="${(window.SB_ASSETS||"")}brand-windgoo.webp" alt="Windgoo">`;
const KOOLUX_LOGO = `<img class="blogo koolux" src="https://cdn.shopify.com/s/files/1/0841/5343/4458/files/brand-koolux.png?v=1792274149&width=240" alt="Koolux">`;
const PIXAR_LOGO = `<img class="blogo pixar" src="${(window.SB_ASSETS||"")}brand-pixar.webp" alt="Pixar">`;
const OUXI_EXTRA = new Set(["V8 1.0 Onderdelen","V8 2.0 tot 4.0 Onderdelen","V8 5.0 tot 8.0 Onderdelen","H9 Onderdelen","V8 Ultra Onderdelen","GT2000 Onderdelen","Mini Fatbikes Onderdelen"]);
function brand(t){
  if(OUXI_EXTRA.has(t)) return OUXI_LOGO + t;
  if(/^\s*qmwheel\b/i.test(t)) return QMW_LOGO + t.replace(/^\s*qmwheel\s*/i,"");
  if(/qmwheel/i.test(t)) return QMW_LOGO + t;
  if(/^\s*ouxi\b/i.test(t)) return OUXI_LOGO + t.replace(/^\s*ouxi\s*/i,"");
  if(/ouxi/i.test(t)) return OUXI_LOGO + t;
  if(/^\s*7go\b/i.test(t)) return SEVENGO_LOGO + t.replace(/^\s*7go\s*/i,"");
  if(/7go/i.test(t)) return SEVENGO_LOGO + t;
  if(/^\s*agm\b/i.test(t)) return AGM_LOGO + t.replace(/^\s*agm\s*/i,"");
  if(/agm/i.test(t)) return AGM_LOGO + t;
  if(/^\s*windgoo\b/i.test(t)) return WINDGOO_LOGO + t.replace(/^\s*windgoo\s*/i,"");
  if(/windgoo/i.test(t)) return WINDGOO_LOGO + t;
  if(/^\s*pixar\b/i.test(t)) return PIXAR_LOGO + t.replace(/^\s*pixar\s*/i,"");
  if(/pixar/i.test(t)) return PIXAR_LOGO + t;
  if(/^\s*koolux\b/i.test(t)) return KOOLUX_LOGO + t.replace(/^\s*koolux\s*/i,"");
  return t;
}
function brandL(t){ const h=brand(t); const k=h.lastIndexOf(">"); return k>-1 && h.startsWith("<img") ? h.slice(0,k+1)+`<span class="bl-t">${h.slice(k+1)}</span>` : `<span class="bl-t">${h}</span>`; }
function ddLinks(items){
  return items.map(([a,b])=> a==="—HEAD—" ? `<a class="head">${tr(b)}</a>` : `<a href="${lp(b)}">${brandL(tr(a))}</a>`).join("");
}
const DD_IC={wrench:"M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z",bike:"M5.5 17a3.5 3.5 0 1 0 0-.01M18.5 17a3.5 3.5 0 1 0 0-.01M5.5 17 9 9h6l3.5 8M9 9 7.5 6H5",key:"M15 7a4 4 0 1 1-3.9 5H3v3h3v-2h2v2h3.1A4 4 0 0 1 15 7z",pin:"M12 21s-7-5.2-7-11a7 7 0 0 1 14 0c0 5.8-7 11-7 11ZM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",chat:"M21 11.5a8 8 0 0 1-11.5 7.2L3 21l2.3-6.5A8 8 0 1 1 21 11.5Z",scale:"M12 3v18M5 7h14M5 7l-3 7a3 3 0 0 0 6 0zM19 7l-3 7a3 3 0 0 0 6 0z",doc:"M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h4",card:"M3 6h18v12H3zM3 10h18M7 15h3",alert:"M12 3 2 20h20L12 3zM12 10v4M12 17h.01",book:"M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2zM4 19V5",shield:"M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z",ret:"M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3",check:"M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6zM9 12l2 2 4-4",help:"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9a2.5 2.5 0 0 1 4.9.7c0 1.7-2.4 2.3-2.4 3.8M12 17h.01"};
function ddCols(n){
  return n.cols.map(c=>`<div class="ddc-col"><span class="ddc-h">${tr(c.head)}</span>${c.items.map(([a,b,d,i])=>`<a href="${lp(b)}" class="ddc-a"><span class="ddc-ic"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${DD_IC[i]||""}"/></svg></span><span class="ddc-t"><b>${tr(a)}</b>${d?`<small>${tr(d)}</small>`:""}</span></a>`).join("")}</div>`).join("")
   + (n.promo?`<a class="ddc-promo${n.promo.green?" g":""}" href="${lp(n.promo.href)}"><b>${tr(n.promo.t)}</b><span>${tr(n.promo.p)}</span><em>${tr(n.promo.cta)}</em></a>`:"");
}
function ddInner(n){
  if(n.cols) return ddCols(n);
  if(n.groups){
    return n.groups.map(g=>`<div class="grp"><a class="grp-t" href="#">${brandL(tr(g.name))}<svg class="rt" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M9 6l6 6-6 6"/></svg></a><div class="mega-panel">${g.items.map(([a,b])=>`<a href="${lp(b)}"><span class="bl-t">${tr(a)}</span></a>`).join("")}</div></div>`).join("");
  }
  return ddLinks(n.items);
}
function ddClass(n){ return n.cols ? "dropdown dd-cols c"+n.cols.length : n.groups ? "dropdown mega" : ("dropdown"+(n.wide?" wide":"")); }
function hasDD(n){ return !!(n.items || n.groups || n.cols); }

// ---- bouw de navigatie + dropdowns ----
var navEl = document.getElementById("mainNav");
if (navEl && !navEl.children.length) navEl.innerHTML = NAV.map(n=>{
  if(n.deals) return `<li><a class="deals" href="${lp(n.href)}">${tr(n.label)}</a></li>`;
  if(!hasDD(n)) return `<li><a href="${lp(n.href)}">${tr(n.label)}</a></li>`;
  return `<li><a href="${lp(n.href)}">${tr(n.label)} CHEV</a><div class="${ddClass(n)}">${ddInner(n)}</div></li>`;
}).join("").replaceAll("CHEV", `<svg class="chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M6 9l6 6 6-6"/></svg>`);

const CAT_PHOTO = {
  "Fatbikes": (window.SB_ASSETS||"")+"cat-fatbikes.webp",
  "CityBikes": (window.SB_ASSETS||"")+"cat-citybikes.webp",
  "Onderdelen": (window.SB_ASSETS||"")+"cat-onderdelen.png",
  "Accessoires": (window.SB_ASSETS||"")+"cat-accessoires.png",
  "Werkplaats": (window.SB_ASSETS||"")+"cat-afspraak.png",
  "Hulp": (window.SB_ASSETS||"")+"cat-overons.webp"
};
function catIcon(n){
  const ov = (window.CAT_PHOTO_OVERRIDE||{})[n.label];
  const p = ov || CAT_PHOTO[n.label];
  if(p) return `<span class="ic ic-photo"><img src="${p}" alt="${tr(n.label)}" loading="lazy"></span>`;
  return `<span class="ic"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="${NAV_ICONS[n.label]||''}"/></svg></span>`;
}
var catEl0 = document.getElementById("catRow");
if (catEl0 && !catEl0.children.length) catEl0.innerHTML = NAV.filter(function(n){return hasDD(n)&&n.label!=="Hulp"}).map(n=>{
  return `<div class="cat-wrap">
    <a class="cat" href="${lp(n.href)}">
      ${catIcon(n)}
      <b>${tr(n.label)}</b>
    </a>
    <div class="${ddClass(n)}">${ddInner(n)}</div>
  </div>`;
}).join("");

const grid = document.getElementById("grid") || {};
function renderGrid(tab){
  const list = tab==="all" ? PRODUCTS : PRODUCTS.filter(p=>p.tag===tab);
  grid.innerHTML = list.map(card).join("");
}
renderGrid("best");

const locGrid = document.getElementById("locGrid") || {style:{},children:[]};
if (!locGrid.children || !locGrid.children.length) {
if (LOCATIONS.length === 1) { locGrid.style.maxWidth = "440px"; locGrid.style.margin = "0 auto"; }
locGrid.innerHTML = LOCATIONS.map(([n,a])=>`
  <div class="loc">
    <div class="img"><span class="open">Open 10:00 – 17:00</span></div>
    <div class="info">
      <h3>${n}</h3>
      <div class="addr">${a}</div>
      <a class="plan" href="#">Plan een proefrit
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </div>
  </div>`).join("");
}

const BRAND_LINK={"OUXI":"/collections/fatbike-ouxi","AGM":"/collections/agm-bike","7GO":"/collections/fatbike-7go-rse","V20":"/collections/fatbike-qmwheel"};
(function(){const bl=document.getElementById("brandList"); if(bl && !bl.children.length){ bl.innerHTML = BRANDS.map(b=>`<a class="brand" href="${lp(BRAND_LINK[b]||'/collections/fatbikes')}">${b}</a>`).join(""); }})();
(document.getElementById("yr")||{}).textContent = new Date().getFullYear();

/* ---------- tabs ---------- */
(document.getElementById("tabs")||{addEventListener:function(){}}).addEventListener("click", e=>{
  const b = e.target.closest("button"); if(!b) return;
  document.querySelectorAll("#tabs button").forEach(x=>x.classList.remove("active"));
  b.classList.add("active");
  renderGrid(b.dataset.tab);
});

/* ---------- cart ---------- */
let cart = 0;
const cartCount = document.getElementById("cartCount");
function toast(msg){
  const t = document.getElementById("toast");
  document.getElementById("toastMsg").textContent = msg;
  t.classList.add("show");
  clearTimeout(t._t); t._t = setTimeout(()=>t.classList.remove("show"), 2200);
}
document.addEventListener("click", e=>{
  const add = e.target.closest(".add");
  if(add){
    cart++; cartCount.textContent = cart;
    add.classList.add("added"); add.firstChild.textContent=tr("Toegevoegd")+" ";
    setTimeout(()=>{ add.classList.remove("added"); add.firstChild.textContent=tr("In mandje")+" "; }, 1200);
    toast(`${add.dataset.name} ${tr("toegevoegd aan je mandje")}`);
  }
});
document.getElementById("cartBtn").addEventListener("click", ()=>{ window.location.href = SB_LR + "/cart"; });

/* ---------- newsletter ---------- */
(document.getElementById("newsForm")||{addEventListener:function(){}}).addEventListener("submit", e=>{
  /* echte inschrijving via Shopify-klantformulier */
});

/* ---------- mobile drawer ---------- */
const scrim=document.getElementById("scrim"), drawer=document.getElementById("drawer");
const openD=()=>{scrim.classList.add("open");drawer.classList.add("open")};
const closeD=()=>{scrim.classList.remove("open");drawer.classList.remove("open")};
document.getElementById("burger").addEventListener("click",openD);
document.getElementById("closeDrawer").addEventListener("click",closeD);
scrim.addEventListener("click",closeD);
drawer.querySelectorAll("a").forEach(a=>a.addEventListener("click",closeD));

/* ---------- categorie-icoon: KLIK opent het keuzemenu (i.p.v. navigeren) ---------- */
(function(){
  var row=document.getElementById("catRow"); if(!row) return;
  function closeAll(){ row.querySelectorAll(".cat-wrap.open,.grp.open").forEach(function(o){o.classList.remove("open");}); }
  row.querySelectorAll(".cat-wrap").forEach(function(w){
    var cat=w.querySelector(".cat"), dd=w.querySelector(".dropdown");
    if(!cat||!dd) return;
    /* klik gaat direct naar de pagina met alle producten */
  });
  row.querySelectorAll(".grp-t").forEach(function(t){
    t.addEventListener("click", function(e){
      e.preventDefault();
      var grp=t.closest(".grp"); if(!grp) return;
      var open=grp.classList.contains("open");
      grp.parentNode.querySelectorAll(".grp.open").forEach(function(o){o.classList.remove("open");});
      if(!open) grp.classList.add("open");
    });
  });
  document.addEventListener("click", function(e){ if(!e.target.closest("#catRow")) closeAll(); });
})();

/* ---------- countdown (telt af naar einde van de dag, dan reset 3 dagen) ---------- */
let target = new Date(); target.setDate(target.getDate()+2); target.setHours(23,59,59,0);
(function(){ var c=document.getElementById("count"); if(c && c.dataset && c.dataset.deadline){ var dl=new Date(c.dataset.deadline+"T23:59:59"); if(!isNaN(dl.getTime())) target=dl; } })();
function tick(){
  let diff = Math.max(0, target - new Date());
  const d=Math.floor(diff/864e5); diff-=d*864e5;
  const h=Math.floor(diff/36e5); diff-=h*36e5;
  const m=Math.floor(diff/6e4); diff-=m*6e4;
  const s=Math.floor(diff/1e3);
  const p=n=>String(n).padStart(2,"0");
  const cu=(document.getElementById("count")||{}).dataset||{};
  (document.getElementById("cd")||{}).textContent=p(d)+(cu.ud||"d");
  (document.getElementById("ch")||{}).textContent=p(h)+(cu.uh||"u");
  (document.getElementById("cm")||{}).textContent=p(m)+(cu.um||"m");
  (document.getElementById("cs")||{}).textContent=p(s)+(cu.us||"s");
}
if(document.getElementById("cd")){ tick(); setInterval(tick,1000); }

/* Dealer login knoppen (Sache) */
(function(){
  var lbl = window.SB_DEALER ? "Dealerportaal" : "DEALER LOGIN";
  var nav=document.getElementById("mainNav");
  /* dealer staat nu in de util-balk */
  var row=document.getElementById("catRow");
  if(row && !row.querySelector(".cat-dealer")) row.insertAdjacentHTML("beforeend",'<div class="cat-wrap"><a class="cat cat-dealer" href="'+lp("/pages/dealer-portaal")+'"><span class="ic"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg></span><b>'+tr(window.SB_DEALER?"Dealerportaal":"Dealer login")+'</b></a></div>');
})();

/* Fatbike huren in menu en categorie-rij (Sache) */
(function(){
  var nav=document.getElementById("mainNav");
  /* huren staat nu onder Werkplaats */
  var row=document.getElementById("catRow");
  if(row && !row.querySelector(".cat-huren")){
    var html='<div class="cat-wrap"><a class="cat cat-huren" href="'+lp("/pages/fatbike-huren-den-haag")+'"><span class="ic"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="5.5" cy="17" r="3.5"/><circle cx="18.5" cy="17" r="3.5"/><path d="M5.5 17 9 9h6l3.5 8M9 9 7.5 6H5m10 3 1.5-3H19"/></svg></span><b>'+tr("Fatbike huren")+'</b></a></div>';
    var dw=row.querySelector(".cat-dealer");
    if(dw && dw.parentNode) dw.parentNode.insertAdjacentHTML("beforebegin",html); else row.insertAdjacentHTML("beforeend",html);
  }
})();

/* Garantie aanvragen: link in footer en mobiel menu (Sache) */
(function(){
  var G=SB_LR+'/pages/garantie', GA=SB_LR+'/pages/garantie-aanvragen', GL=tr('Garantie of melding doen');
  var g=document.querySelector('footer a[href="'+G+'"]');
  if(g && !document.querySelector('footer a[href="'+GA+'"]')){ var li=g.closest('li'); if(li) li.insertAdjacentHTML('afterend','<li><a href="'+GA+'">'+GL+'</a></li>'); }
  var d=document.querySelector('#drawer a[href="'+G+'"]');
  if(d && !document.querySelector('#drawer a[href="'+GA+'"]')){ d.insertAdjacentHTML('beforebegin','<a href="'+GA+'">'+GL+'</a>'); }
})();
